var render = function render(){var _vm=this,_c=_vm._self._c;return _c('paginate',{attrs:{"page-count":_vm.pageCount,"page-range":3,"margin-pages":2,"prev-text":'قبلی',"next-text":'بعدی',"container-class":'pagination',"page-class":'page-item'},model:{value:(_vm.valData),callback:function ($$v) {_vm.valData=$$v},expression:"valData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }